import ButtonBlue from '../../common/ButtonBlue/ButtonBlue';
import Button from '../../common/Button/Button';
import styles from './Contact.module.scss';
import { useNavigate } from 'react-router-dom';
// =======================
// ICONS
// =======================
import { FaFacebookF, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.contact}>
      <h1 className={styles.title}> Umów się </h1>
      <p>
        Skontaktuj się z nami - odpowiemy i pomożemy dobrać odpowiednią formę
        wsparcia.
      </p>
      {/* first block */}
      <div className={styles.box}>
        <div className={styles.square}>
          <h3>Kontakt</h3>
          <ul>
            <li>
              Tel: <a href='tel:+48668700455'>668 700 455</a>
            </li>
            <li className={styles.email}>
              E-mail:
              <a href='mailto: centrumrozwojumotus@gmail.com'>
                centrumrozwojumotus@gmail.com
              </a>
            </li>
          </ul>

          <div className={styles.socials}>
            <ul>
              <li>
                <a
                  href='https://wa.me/+48668700455'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaWhatsapp className={styles.whatsapp}></FaWhatsapp>
                </a>
              </li>
              <li>
                <a
                  href='https://www.facebook.com/CRTMOTUS'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaFacebookF className={styles.facebook} />
                </a>
              </li>
              <li>
                <a
                  href='https://www.instagram.com/crtmotus/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaInstagram className={styles.instagram} />
                </a>
              </li>
            </ul>
          </div>

          <ButtonBlue onCilck={() => navigate('/contact')}>
            Napisz do nas
          </ButtonBlue>
        </div>
        {/* second block */}
        <div className={styles.square}>
          <h3> Godziny otwarcia </h3>
          <ul>
            <li>Poniedziałek - Piątek: 8:00 - 20:00</li>
            <li>Sobota - Niedziela: Nieczynne</li>
          </ul>
          <div className={styles.socials}>
            <ul>
              <li>
                <a
                  href='https://wa.me/+48668700455'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaWhatsapp className={styles.whatsapp}></FaWhatsapp>
                </a>
              </li>
              <li>
                <a
                  href='https://www.facebook.com/CRTMOTUS'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaFacebookF className={styles.facebook} />
                </a>
              </li>
              <li>
                <a
                  href='https://www.instagram.com/crtmotus/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <FaInstagram className={styles.instagram} />
                </a>
              </li>
            </ul>
          </div>
          <Button>
            <a
              href='https://www.google.com/maps?q=Centrum+Rozwoju+i+Terapii+Motus,+Niepołomice'
              target='_blank'
              rel='noopener noreferrer'
            >
              Adres: Targowa 6d, 32-005 Niepołomice
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Contact;
